import { _deserializable } from '../_deserializable';

export class EligibleItemsRequest extends _deserializable {

  public customer: string;

}
